import styled from "@xstyled/styled-components";
import { tokens } from "../utils/theme";

export const TopBarContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 10px 20px;
  margin: -18px -20px 12px;
  background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(10, 13, 22, 0.9)' : 'rgba(255, 255, 255, 0.70)'};
  border-bottom: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(130, 170, 255, 0.18)' : 'rgba(15, 23, 42, 0.14)'};
`;

export const TopBarInner = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const ThemeToggle = styled.button`
  width: 30px;
  height: 30px;
  border-radius: 999px;
  border: 1px solid ${props => tokens(props.theme.palette.mode).grey[500]};
  background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(17, 20, 33, 0.96)' : 'rgba(255, 255, 255, 0.78)'};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: ${props => tokens(props.theme.palette.mode).grey[400]};
  padding: 0;
  transition: all 0.18s ease-out;

  &:hover {
    background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(26, 30, 48, 0.98)' : 'rgba(255, 255, 255, 0.92)'};
    border-color: ${props => props.theme.palette.mode === 'dark' ? 'rgba(130, 170, 255, 0.7)' : 'rgba(15, 118, 110, 0.35)'};
    color: ${props => tokens(props.theme.palette.mode).grey[100]};
    transform: translateY(-1px);
    box-shadow: 0 0 12px ${props => props.theme.palette.mode === 'dark' ? 'rgba(130, 170, 255, 0.35)' : 'rgba(15, 118, 110, 0.18)'};
  }
`;

export const ThemeToggleIcon = styled.span`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: ${props => props.theme.palette.mode === 'dark'
    ? 'radial-gradient(circle at 30% 0, #ffcb6b, #ff5370)'
    : 'radial-gradient(circle at 35% 30%, #FFF7C2, #F2D36B)'};
  color: ${props => props.theme.palette.mode === 'dark' ? '#111' : '#7a5b00'};
  font-size: 12px;
  box-shadow: ${props => props.theme.palette.mode === 'dark' ? 'none' : '0 0 0 3px rgba(242, 211, 107, 0.22)'};
`;

export const UserMenu = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 6px 10px;
  border-radius: 20px;
  background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(14, 18, 30, 0.98)' : 'rgba(255, 255, 255, 0.72)'};
  border: 1px solid ${props => props.theme.palette.mode === 'dark' ? '#252a3e' : tokens(props.theme.palette.mode).grey[500]};
  user-select: none;
  cursor: pointer;
  position: relative;
  transition: all 0.2s;
  z-index: 1001;

  ${props => props.isOpen && `
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    background: ${props.theme.palette.mode === 'dark' ? 'rgba(16, 20, 33, 0.98)' : 'rgba(255, 255, 255, 0.95)'};
    border-color: ${props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)'};
    border-bottom-color: transparent;
  `}

  &:hover {
    background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(20, 24, 36, 0.98)' : 'rgba(255, 255, 255, 0.9)'};
    border-color: ${props => props.theme.palette.mode === 'dark' ? '#3a415e' : tokens(props.theme.palette.mode).grey[400]};
    
    ${props => props.isOpen && `
      background: ${props.theme.palette.mode === 'dark' ? 'rgba(16, 20, 33, 0.98)' : 'rgba(255, 255, 255, 0.95)'};
      border-color: ${props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)'};
      border-bottom-color: transparent;
    `}
  }
`;

// ... (UserAvatar, UserInfo, UserName, UserStatus, StatusIndicator remain unchanged)

export const UserAvatar = styled.div`
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: ${props => props.theme.palette.mode === 'dark'
    ? 'radial-gradient(circle at 30% 0, rgba(128, 203, 196, 0.22), rgba(21, 24, 39, 0.95))'
    : 'rgba(255, 255, 255, 0.80)'};
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: ${props => props.theme.palette.mode === 'dark'
    ? '0 0 0 1px rgba(128, 203, 196, 0.45), 0 0 14px rgba(128, 203, 196, 0.35)'
    : '0 10px 24px rgba(15, 118, 110, 0.10)'};
  color: ${props => props.theme.palette.mode === 'dark' ? '#98fff2' : '#0b3b35'};
  border: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.06)' : 'rgba(15, 118, 110, 0.22)'};
  flex: 0 0 auto;
`;

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 11px;
`;

export const UserName = styled.div`
  font-size: 12px;
  color: ${props => tokens(props.theme.palette.mode).grey[100]};
`;

export const UserStatus = styled.div`
  color: ${props => tokens(props.theme.palette.mode).grey[400]};
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const StatusIndicator = styled.span`
  color: ${props => tokens(props.theme.palette.mode).blueAccent[500]};
  font-weight: 800;
  display: inline-flex;
  align-items: center;
  gap: 6px;

  &::before {
    content: "";
    display: inline-block;
    width: 7px;
    height: 7px;
    border-radius: 999px;
    background: #22c55e;
    box-shadow: 0 0 0 3px rgba(34,197,94,0.12);
  }
`;

export const DropdownContainer = styled.div`
  position: absolute;
  top: 100%;
  left: -1px;
  right: -1px;
  background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(16, 20, 33, 0.98)' : 'rgba(255, 255, 255, 0.95)'};
  backdrop-filter: blur(10px);
  border: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)'};
  border-top: none;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  overflow: hidden;
  animation: unroll 0.2s ease-out forwards;
  transform-origin: top;

  @keyframes unroll {
    from { 
      opacity: 0;
      transform: scaleY(0);
    }
    to { 
      opacity: 1;
      transform: scaleY(1);
    }
  }
`;

export const DropdownItem = styled.div`
  padding: 12px 16px;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.3px;
  color: ${props => tokens(props.theme.palette.mode).grey[100]};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center; /* Center text since no icon */
  transition: all 0.2s ease;
  border-left: 2px solid transparent;

  &:hover {
    background: ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)'};
    /* Removed padding-left shift and border-left color for a cleaner text-only look, or keep it? 
       User wanted "cleaner". Centered text might be nice for a "pill" feel. 
       Let's stick to left align but maybe less shift. */
    padding-left: 20px;
    border-left-color: ${props => tokens(props.theme.palette.mode).blueAccent[500]};
  }

  &:not(:last-child) {
    border-bottom: 1px solid ${props => props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.03)' : 'rgba(0, 0, 0, 0.03)'};
  }
`;
